import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  accordion: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 5,
    '&::before': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  contentContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
}));

export default styles;